import React, { Component } from "react";
import QVFourEmailAndWebsiteFooter from "views/Pma/PmaEditor/SecondPageComponents/QVFourEmailAndWebsiteFooter";
import "./print.scss";
import DashboardQRCode from "views/Pma/PmaEditor/SecondPageComponents/PropAttributes/DashboardQRCode";

class FullSecondPageImage extends Component {
  render() {
    const { agentData, printVersion, currentArea, hoData } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;

    if (listgenUserID === "100462") {
      return (
        <div className="ye2-second-left">
          <div className="full-second-page-image-container">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/091026_KristinArntz_Page-2.jpg"
              className="full-100-second-page"
              alt="Kristin Arntz Second Page September 2026"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "101001") {
      return (
        <div className="ye2-second-left">
          <div className="full-second-page-image-container">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/080726_AnnetteVAIT_Dashboard-1.jpg"
              className="full-second-page-image"
              alt="Annette Vait Second Page August 2026"
            />
          </div>
        </div>
      );
    } else if (listgenUserID === "109705") {
      return (
        <div className="ye2-second-left">
          <div className="full-second-page-image-container show-dashboard-qr">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/030926_KurtPiper_Dashboard-Pg2_crop_light.jpg"
              className="full-second-page-image"
              alt="Kurt Piper Second Page March 2026"
            />
          </div>
          <DashboardQRCode
            agentData={agentData}
            printVersion={printVersion}
            currentArea={currentArea}
            hoData={hoData}
          />
          <QVFourEmailAndWebsiteFooter
            agentData={agentData}
            printVersion={printVersion}
            currentArea={currentArea}
          />
        </div>
      );
    } else if (listgenUserID === "100560") {
      return (
        <div className="ye2-second-left">
          <div className="full-second-page-image-container">
            <img
              src="https://d2onbxnrte2nim.cloudfront.net/non-covers/110426_Nov26-Page2_KerryMormann-v2.jpg"
              className="full-second-page-image"
              alt="Kerry Mormann Second Page November 2026 V2"
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h1>Full Second Page Image</h1>
        </div>
      );
    }
  }
}

export default FullSecondPageImage;
